import http from "../../http-common";

class ConvergencePagesMenuService {
    getConvergencePagesMenu(path: string) {
        return http.get(`/convergence-pages-menu?path=${path}`);
    }
}

export default new ConvergencePagesMenuService();
